import React from 'react';


const ChatFAB = ({ onClick, unreadCount = 0 }) => {
    return (
        <button
            className="v-ch-fab"
            onClick={onClick}
            aria-label="Open Chat"
        >
            <iframe
                src="https://lottie.host/embed/ccf52ea1-9c93-485d-8ebe-87a72aa96a2f/dgxpFE8G1R.lottie"
                style={{ width: '105px', height: '125px', border: 'none', pointerEvents: 'none' }}
                title="Chat Bot"
            ></iframe>
            {unreadCount > 0 && (
                <span className="v-ch-badge">{unreadCount}</span>
            )}
        </button>
    );
};

export default ChatFAB;
